import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import { numberWithCommas } from 'helper';

function ShowTransactionInfo({ transactionInfo, isLoading, handleAdd }) {
  const permissions = getJson('permissions');

  const createMarkup = remarksData => {
    return { __html: remarksData };
  };

  function UpdateRemarks() {
    if (
      _.get(transactionInfo, 'attributes.is_start_assessment') === 1 &&
      Acl(permissions, ['REMARKS BPLS'])
    ) {
      return (
        <button
          disabled={isLoading}
          type="button"
          onClick={handleAdd(transactionInfo)}
          className="btn btn-warning btn-round font-weight-bold"
        >
          {isLoading ? (
            <i className="fa fa-spin fa-spinner" />
          ) : (
            <>
              {!_.isEmpty(
                _.get(transactionInfo, 'included.module.attributes.remarks')
              )
                ? 'Edit Remarks'
                : 'Add Remarks'}
            </>
          )}
        </button>
      );
    }

    if (
      _.get(transactionInfo, 'attributes.paid_at') &&
      +_.get(transactionInfo, 'attributes.is_start_assessment') === 0 &&
      Acl(permissions, ['UPDATE PAID BPLS REMARKS'])
    ) {
      return (
        <button
          disabled={isLoading}
          type="button"
          onClick={handleAdd(transactionInfo)}
          className="btn btn-warning btn-round font-weight-bold"
        >
          {isLoading ? (
            <i className="fa fa-spin fa-spinner" />
          ) : (
            <>
              {!_.isEmpty(
                _.get(transactionInfo, 'included.module.attributes.remarks')
              )
                ? 'Edit Remarks'
                : 'Add Remarks'}
            </>
          )}
        </button>
      );
    }

    return '';
  }

  return (
    <>
      <table className="transaction-table table table-borderless table-sm table-striped table-hover">
        <tbody>
          <tr>
            <td className="text-dark" width="300">
              Application Date
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>
                {(
                  _.get(
                    transactionInfo,
                    'included.module.attributes.application_date'
                  ) || '--'
                ).toUpperCase()}
              </b>
            </td>
          </tr>

          <tr>
            <td className="text-success" colSpan={3}>
              <b>TAX PAYER&apos;S INFORMATION</b>
            </td>
          </tr>

          <tr>
            <td className="text-dark" width="300">
              Last Name
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>
                {(
                  _.get(
                    transactionInfo,
                    'included.module.attributes.tax_payer_last_name'
                  ) || '--'
                ).toUpperCase()}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="300">
              First Name
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>
                {(
                  _.get(
                    transactionInfo,
                    'included.module.attributes.tax_payer_first_name'
                  ) || '--'
                ).toUpperCase()}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="300">
              Middle Name
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>
                {(
                  _.get(
                    transactionInfo,
                    'included.module.attributes.tax_payer_middle_name'
                  ) || '--'
                ).toUpperCase()}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="300">
              Extension Name
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>
                {(
                  _.get(
                    transactionInfo,
                    'included.module.attributes.tax_payer_extension_name'
                  ) || '--'
                ).toUpperCase()}
              </b>
            </td>
          </tr>

          <tr>
            <td className="text-success" colSpan={3}>
              <b>BUSINESS INFORMATION</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="300">
              BIN
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>
                {(
                  _.get(transactionInfo, 'included.module.attributes.bin') ||
                  '--'
                ).toUpperCase()}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="300">
              Business Name
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>
                {(
                  _.get(
                    transactionInfo,
                    'included.module.attributes.business_name'
                  ) || '--'
                ).toUpperCase()}
              </b>
            </td>
          </tr>

          <tr>
            <td className="text-success" colSpan={3}>
              <b>DETAILS</b>
            </td>
          </tr>

          <tr>
            <td className="text-dark" width="300">
              Telephone number
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>
                {(
                  _.get(
                    transactionInfo,
                    'included.module.attributes.telephone_no'
                  ) || '--'
                ).toUpperCase()}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="300">
              Address
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>
                {(
                  _.get(
                    transactionInfo,
                    'included.module.attributes.address'
                  ) || '--'
                ).toUpperCase()}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="300">
              Nationality
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>
                {(
                  _.get(
                    transactionInfo,
                    'included.module.attributes.nationality'
                  ) || '--'
                ).toUpperCase()}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="300">
              Number of Employees
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>
                {_.get(
                  transactionInfo,
                  'included.module.attributes.no_of_employees'
                ) || '0'}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="300">
              Area
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>
                {_.get(transactionInfo, 'included.module.attributes.area') ||
                  '0'}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="300">
              E-SOA Number
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>
                {(
                  _.get(
                    transactionInfo,
                    'included.module.attributes.e_soa_no'
                  ) || '--'
                ).toUpperCase()}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="300">
              SOA Generated at
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>
                {(
                  _.get(
                    transactionInfo,
                    'included.module.attributes.soa_generated_at'
                  ) || '--'
                ).toUpperCase()}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="300">
              E-OR Number
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>
                {(
                  _.get(
                    transactionInfo,
                    'included.module.attributes.e_or_no'
                  ) || '--'
                ).toUpperCase()}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="300">
              OR Generated at
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>
                {(_.get(transactionInfo, 'attributes.transaction_paid_date')
                  ? _.get(transactionInfo, 'attributes.transaction_paid_date')
                  : _.get(transactionInfo, 'attributes.paid_at') || '--'
                ).toUpperCase()}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="300">
              E-Permit Number
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>
                {(
                  _.get(
                    transactionInfo,
                    'included.module.attributes.e_permit_no'
                  ) || '--'
                ).toUpperCase()}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="300">
              Permit Generated at
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>
                {(
                  _.get(
                    transactionInfo,
                    'included.module.attributes.permit_generated_at'
                  ) || '--'
                ).toUpperCase()}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="300">
              Ownership
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>
                {(
                  _.get(
                    transactionInfo,
                    'included.module.attributes.ownership'
                  ) || '--'
                ).toUpperCase()}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="300">
              E-mail Address
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>
                {(
                  _.get(
                    transactionInfo,
                    'included.module.attributes.email_address'
                  ) || '--'
                ).toUpperCase()}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="300">
              TIN Number:
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>
                {(
                  _.get(transactionInfo, 'included.module.attributes.tin_no') ||
                  '--'
                ).toUpperCase()}
              </b>
            </td>
          </tr>

          <tr>
            <td className="text-success" colSpan={3}>
              <b>INCOME</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="300">
              Gross Income
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td>
              <b>
                PHP{' '}
                {numberWithCommas(
                  _.get(
                    transactionInfo,
                    'included.module.attributes.gross_amount_human'
                  ) || '--'
                )}
              </b>
            </td>
          </tr>
        </tbody>
      </table>
      {/* add remarks  */}
      <hr className="ct-hr" />
      <table className="w-100 transaction-table table table-borderless table-sm table-striped table-hover">
        <tbody>
          <tr />
          <tr className="">
            <td className="text-success" colSpan={3}>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <b>REMARKS</b>
                <UpdateRemarks />
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={5}>
              <div className="w-100 my-2 p-2">
                <b className="text-wrap text-break">
                  <div
                    // eslint-disable-next-line
                    dangerouslySetInnerHTML={createMarkup(_.get(
                      transactionInfo,
                      'included.module.attributes.remarks'
                    ) || '--')}
                  />
                </b>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
}

ShowTransactionInfo.propTypes = {
  transactionInfo: PropTypes.instanceOf(Object).isRequired,
  handleAdd: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default ShowTransactionInfo;
